import Button from "../../../../Custom/Button/Button";
import { useEffect, useState, useRef } from "react";
import { useGlobalContext } from "../../../../../Context/Context";
import VazecaTabela from "./RadnoMestoDokVazeca";
import ArhiviranaTabela from "./RadnoMestoDokArhivirana";
import axios from "axios";

const styles = {
  button: { padding: "5px 30px", fontWeight: "bold" },
  label: { fontWeight: "bold", fontSize: "16px", marginBottom: "5px" },
  input: { height: "40px", padding: "10px", fontSize: "16px", width: "100%" },
};

const emptyNewDoc = {
  naziv: "",
  brojDokumenta: "",
  datumIsteka: "",
};

function RadnoMestoDokumenta({ id, cancel }) {
  const [vazecaDokumenta, setVazecaDokumenta] = useState([]);
  const [arhiviranaDokumenta, setArhiviranaDokumenta] = useState([]);

  const [checkedRowsVazeci, setCheckedRowsVazeci] = useState([]);
  const [isCheckedAllVazeci, setIsCheckedAllVazeci] = useState(false);
  const [checkedRowsArhivirani, setCheckedRowsArhivirani] = useState([]);
  const [isCheckedAllArhivirani, setIsCheckedAllArhivirani] = useState(false);

  const [isDodavanje, setIsDodavanje] = useState(false);
  const [newDoc, setNewDoc] = useState(emptyNewDoc);
  const [pendingFile, setPendingFile] = useState(null);

  const fileInputRef = useRef();
  const { dictionary, baseUrl } = useGlobalContext();

  const fetchDokumenta = async () => {
    try {
      const { data } = await axios.post(
        `${baseUrl}/workplaces/readDocuments.php`,
        { workplace_id: id },
      );
      if (data.status === 200) {
        setVazecaDokumenta(data.vazeca);
        setArhiviranaDokumenta(data.arhivirana);
      }
    } catch (e) {
      console.error("Greška:", e);
    }
  };

  useEffect(() => {
    if (!id) return;
    fetchDokumenta();
  }, [id]);

  const moveToArhivirani = async (dokument) => {
    try {
      await axios.post(`${baseUrl}/workplaces/archiveDocument.php`, {
        id: dokument.id,
      });
      fetchDokumenta();
    } catch (e) {
      console.error("Greška:", e);
    }
  };

  const moveToVazeci = async (dokument) => {
    try {
      await axios.post(`${baseUrl}/workplaces/restoreDocument.php`, {
        id: dokument.id,
      });
      fetchDokumenta();
    } catch (e) {
      console.error("Greška:", e);
    }
  };

  const handleChange = (value, field) => {
    setNewDoc((prev) => ({ ...prev, [field]: value }));
  };

  const handleOdustani = () => {
    setIsDodavanje(false);
    setNewDoc(emptyNewDoc);
    setPendingFile(null);
  };

  const getColumnFromFile = (file) => {
    const ext = file.name.split(".").pop().toLowerCase();
    if (["jpg", "jpeg", "png", "webp"].includes(ext)) return "image";
    if (ext === "pdf") return "pdf";
    if (["doc", "docx"].includes(ext)) return "word";
    return "scan";
  };

  const handleSacuvaj = async () => {
    if (!newDoc.naziv || !pendingFile) return;
    try {
      const formData = new FormData();
      formData.append("file", pendingFile);
      formData.append("workplace_id", id);
      formData.append("naziv", newDoc.naziv);
      formData.append("broj_dokumenta", newDoc.brojDokumenta);
      formData.append("column", getColumnFromFile(pendingFile));
      if (newDoc.datumIsteka)
        formData.append("datum_isteka", newDoc.datumIsteka);

      const { data } = await axios.post(
        `${baseUrl}/workplaces/uploadDocument.php`,
        formData,
      );
      if (data.status === 200) {
        fetchDokumenta();
        handleOdustani();
      }
    } catch (e) {
      console.error("Greška:", e);
    }
  };

  const isDisabledSacuvaj = !newDoc.naziv || !pendingFile;

  return (
    <div style={{ padding: "5px", backgroundColor: "#f9f9f9", height: "100%" }}>
      <div style={{ overflowY: "auto", height: "calc(100% - 120px)" }}>
        <VazecaTabela
          dokumenta={vazecaDokumenta}
          moveToArhivirani={moveToArhivirani}
          checkedRows={checkedRowsVazeci}
          setCheckedRows={setCheckedRowsVazeci}
          isCheckedAll={isCheckedAllVazeci}
          setIsCheckedAll={setIsCheckedAllVazeci}
          onRefresh={fetchDokumenta}
        />
        <div style={{ marginTop: "20px" }}>
          <ArhiviranaTabela
            dokumenta={arhiviranaDokumenta}
            moveToVazeci={moveToVazeci}
            checkedRows={checkedRowsArhivirani}
            setCheckedRows={setCheckedRowsArhivirani}
            isCheckedAll={isCheckedAllArhivirani}
            setIsCheckedAll={setIsCheckedAllArhivirani}
            onRefresh={fetchDokumenta}
          />
        </div>
      </div>

      {isDodavanje && (
        <div
          style={{
            display: "flex",
            gap: "10px",
            alignItems: "flex-end",
            marginTop: "10px",
          }}
        >
          <div style={{ flex: 2 }}>
            <div style={styles.label}>
              {dictionary["nazivDokumenta"] || "NAZIV"}
            </div>
            <input
              value={newDoc.naziv}
              onChange={(e) => handleChange(e.target.value, "naziv")}
              style={styles.input}
            />
          </div>
          <div style={{ flex: 1 }}>
            <div style={styles.label}>
              {dictionary["brojDokumenta"] || "BROJ"}
            </div>
            <input
              value={newDoc.brojDokumenta}
              onChange={(e) => handleChange(e.target.value, "brojDokumenta")}
              style={styles.input}
            />
          </div>
          <div style={{ flex: 1 }}>
            <div style={styles.label}>
              {dictionary["datumIsteka"] || "DATUM ISTEKA"}
            </div>
            <input
              type="date"
              value={newDoc.datumIsteka}
              onChange={(e) => handleChange(e.target.value, "datumIsteka")}
              style={styles.input}
            />
          </div>
          <div
            onClick={isDisabledSacuvaj ? undefined : handleSacuvaj}
            style={{ opacity: isDisabledSacuvaj ? 0.5 : 1 }}
          >
            <Button activation={true} style={styles.button}>
              {dictionary["sacuvaj"]}
            </Button>
          </div>
          <div onClick={handleOdustani}>
            <Button activation={true} style={styles.button}>
              {dictionary["odustani"]}
            </Button>
          </div>
        </div>
      )}

      <div style={{ display: "flex", gap: "20px", marginTop: "10px" }}>
        <div style={{ fontWeight: "bold", fontSize: "30px", width: "25%" }}>
          245.
        </div>
        <div style={{ width: "25%" }}>
          <Button activation={true} style={styles.button}>
            {dictionary["stampaj"]}
          </Button>
        </div>
        <div style={{ width: "25%" }}>
          <Button activation={true} style={styles.button}>
            {dictionary["posalji"]}
          </Button>
        </div>
        <div onClick={cancel} style={{ width: "25%" }}>
          <Button activation={true} style={styles.button}>
            {dictionary["nazad"]}
          </Button>
        </div>
        <div
          onClick={() => {
            fileInputRef.current.value = "";
            fileInputRef.current.click();
          }}
          style={{ width: "25%" }}
        >
          <Button activation={true} style={styles.button}>
            {dictionary["dodaj"]}
          </Button>
        </div>
      </div>

      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        accept="image/*, .pdf, .docx"
        onChange={(e) => {
          const file = e.target.files[0];
          if (!file) return;
          setPendingFile(file);
          setIsDodavanje(true);
        }}
      />
    </div>
  );
}

export default RadnoMestoDokumenta;
